import type { ScanSessionState, ScanSessionVm } from './types'

export function scanSessionVm(state: ScanSessionState): ScanSessionVm {
  return {
    created: state.created,
    attached: state.attached,
    found: state.found,
    skipped: state.skipped,
    summary: `Создано ${state.created} · Прикреплено ${state.attached} · Найдено ${state.found} · Пропущено ${state.skipped}`,
    entries: state.log,
    last: state.log.find((entry) => entry.kind !== 'skipped') ?? null,
  }
}
